import { render, staticRenderFns } from "./bannerWithPuzzle.vue?vue&type=template&id=028d904b&scoped=true"
import script from "./bannerWithPuzzle.vue?vue&type=script&lang=js"
export * from "./bannerWithPuzzle.vue?vue&type=script&lang=js"
import style0 from "./bannerWithPuzzle.vue?vue&type=style&index=0&id=028d904b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d904b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028d904b')) {
      api.createRecord('028d904b', component.options)
    } else {
      api.reload('028d904b', component.options)
    }
    module.hot.accept("./bannerWithPuzzle.vue?vue&type=template&id=028d904b&scoped=true", function () {
      api.rerender('028d904b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/components/bannerWithPuzzle.vue"
export default component.exports